import { render, staticRenderFns } from "./FieldsDisplay.vue?vue&type=template&id=21ae9d44&scoped=true"
import script from "./FieldsDisplay.vue?vue&type=script&lang=js"
export * from "./FieldsDisplay.vue?vue&type=script&lang=js"
import style0 from "./FieldsDisplay.vue?vue&type=style&index=0&id=21ae9d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae9d44",
  null
  
)

export default component.exports